import React from "react";
import { Form } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { useHistory } from "react-router";
import { useAlertActions } from "../../context/AlertContext";
import { submitOrder } from "../../helpers";

const OrderForm = ({ children }) => {
  const history = useHistory();
  const { setAlert } = useAlertActions();
  const { formRef, handleSubmit } = useFormContext();

  return (
    <Form
      ref={formRef}
      onSubmit={handleSubmit(
        async (data) =>
          await submitOrder(data)
            .then(() => history.push("/submitted"))
            .catch(({ res }) => {
              console.error("❗️ - OrderForm - res", res);
              setAlert("Sorry, something went wrong. Please give us a call.");
            })
      )}
    >
      {children}
    </Form>
  );
};

export default React.memo(OrderForm);
